import React from 'react';

// Fixes bug in Slate where users could not type a beginning of a Variant.
const ZeroWidthSpace = () => (
    <span
        data-slate-zero-width="z"
        data-slate-length="0"
        contentEditable={false}
        suppressContentEditableWarning={true}
    >
        &#65279;
    </span>
);

export default ZeroWidthSpace;
